import React, { useMemo } from 'react';
import { getVerifiedRole } from '../../utils/index';
import { ACNT_ASSOCIATE_ROLE } from '../../constants';
import { getAppConfigData } from '../../config/config';

const Chat = ({ location }) => {
  const url = window.location.href;
  const origin = window.location.origin;

  const isChatRoute = !/\/reviewer\/|\/admin\/|\/health|\/finance-report|\/not-found/.test(location);
  if (!isChatRoute) {
    return <></>;
  } else {
    const verifiedRole = useMemo(() => getVerifiedRole([ACNT_ASSOCIATE_ROLE], url), [url]);

    const appConfig = useMemo(() => getAppConfigData(), [origin]);
    const onAssociatePage = verifiedRole && isChatRoute;

    return onAssociatePage ? (
      <mfaas-module
        name="@ebs-risktech-gr-mfe/philanthropy-chat"
        environment={appConfig.mfaasEnvironment}
        root-prop-channel="acnt"
        root-prop-portal="acnt"
        root-prop-consumerid={appConfig.consumerId}
        root-prop-bearercookies="authorization=authorization,token-chat=token"
        static-server={appConfig.mfaasStaticServer}
        config-service={appConfig.mfaasConfigService}
        shadow-mode="open"
        data-testid="chat-mfaas-module"
      />
    ) : (
      <></>
    );
  }
};

export default React.memo(Chat);
